import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)


// Eigene Erkennungsfunktion für das Land
const customLanguageDetector = {
    name: 'customLanguageDetector',
    lookup() {
        const storedLanguage = localStorage.getItem('i18nextLng');
        if (storedLanguage) return storedLanguage;

        // Falls keine Sprache gespeichert wurde → System-Sprache ermitteln
        const navigatorLang = navigator.language || navigator.languages[0] || 'en';
        const countryCode = navigatorLang.split('-')[1]?.toUpperCase();
        const germanSpeakingCountries = ['DE', 'AT', 'CH'];

        return germanSpeakingCountries.includes(countryCode) ? 'de' : 'en';
    }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customLanguageDetector);

export const defaultNS = 'translation';


i18n
    .use(Backend)
    .use(languageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        supportedLngs: ['de', 'en'],
        fallbackLng: 'en',
        defaultNS,
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        detection: {
            order: ['customLanguageDetector', 'localStorage', 'navigator'], // Unsere Logik kommt zuerst
            caches: ['localStorage'] // Speichert die Sprache in localStorage
        }
    });


export default i18n;